<template>
    <v-select 
       :value="selected_language" 
       v-bind:items="ares_languages"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense" 
       :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    watch:{
        selected_language: {            
            handler(){
                // this is needed when the selected language is set from outside this component
                // the change-event will not fire so we watch the value and emit the change if needed
                this.$emit('updateData', {field: this.field, value: this.selected_language===null ? 'EN' : this.selected_language});
            } 
        },
    },    
    props: {
        selected_language: {
            type: String,
            default: 'EN'
        },    
        ares_languages: {
            type: Array,
            default: function() { return [
                {code: 'EN', description: 'English'},
                {code: 'NL', description: 'Dutch'},
                {code: 'FR', description: 'French'},
                {code: 'DE', description: 'German'}]; },
        },            
        label: String,
        field: {
            type: String,
            default: 'taalcode',
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        showInactive: {
            type: Boolean,
            default: false
        },
        isDense:{
            type: Boolean,
            default: true
        }
    },
    methods: {
        getAresLanguages() {
            return [
                {code: 'EN', description: 'English'},
                {code: 'NL', description: 'Dutch'},
                {code: 'FR', description: 'French'},
                {code: 'DE', description: 'German'},
            ];
        },
        updateData(v){
            // the prop must be updated. You cannot do it directly 
            // so you must update the parent field with an emit
            this.$emit('updateData', { "field": this.field, "value": v === null ? 'EN' : v })
        }
    }
}

</script>